<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">{{ visualizar ? 'Detalhes Variável' : 'Cadastrar Variável' }}</span>

    @if(!visualizar){
      <form [formGroup]="formVariavel" (ngSubmit)="salvar()">
        <div class="main-modal-lateral-edicao">
          @if (variavel.id) {
            <app-slide-toggle-padrao [valor]="variavel.ativo" (changeValue)="variavel.ativo = $event; alteracaoService.camposAlterado()"></app-slide-toggle-padrao>
          }
          <app-form-field formControlName="nome" label="Nome" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>

          <app-select-one
            formControlName="tipo"
            label="Tipo (número, letra, alfanumerico)"
            [listaInput]="tipos"
            chaveCompare="value"
            campo="label"
            widthFormField="100%"
            heightFormField="35px"
            (selecionarItem)="alteracaoService.camposAlterado()"
          >
          </app-select-one>

          <app-form-field formControlName="minCaracteres" label="Min" [type]="'number'" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>
          <app-form-field formControlName="maxCaracteres" label="Max" [type]="'number'" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>

          <div class="align-campo-pesquisa">
            <p>Variável de pesquisa?</p>
            <app-slide-toggle-padrao
              [labelTrue]="'Sim'"
              [labelFalse]="'Não'"
              [valor]="variavel.isPesquisa"
              (changeValue)="variavel.isPesquisa = $event; alteracaoService.camposAlterado()"
            ></app-slide-toggle-padrao>
          </div>

        </div>
      </form>
    }@else {

      <div class="main-modal-lateral-info">

        <div class="container-info-modal-lateral">
          <span class="label">Nome</span>
          <span class="font-12">{{ variavel.nome }}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Tipo</span>
          <span class="font-12">{{ getLabel(variavel.tipo!) }}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Max Caracteres</span>
          <span class="font-12">{{ variavel.maxCaracteres }}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Min Caracteres</span>
          <span class="font-12">{{ variavel.minCaracteres }}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Variável de pesquisa?</span>
          <span class="font-12">{{ variavel.isPesquisa ? 'Sim' : 'Não' }}</span>
        </div>

      </div>
    }

  </div>

  @if (!visualizar) {
    <div class="botoes-modal-lateral">

      <app-button-padrao
        width="100%"
        label="Salvar"
        [backgroundColor]="formVariavel.invalid ? 'grey' : 'var(--verde-padrao)'"
        [color]="formVariavel.invalid ? 'dark-grey' : 'white'"
        [type]="'submit'"
        [disabled]="formVariavel.invalid"
        (buttonClick)="salvar()"
      ></app-button-padrao>

      <app-button-padrao
        width="100%"
        label="Cancelar"
        backgroundColor="white"
        color="var(--vermelho-padrao)"
        (buttonClick)="cancelar()"
        borderColor="var(--vermelho-padrao)"
        borderStyle="solid"
        borderWidth="1px"
      ></app-button-padrao>

    </div>
  }

</div>
